export const VERIFY_PHONE_START = 'VERIFY_PHONE_START';
export const VERIFY_PHONE_SUCCESS = 'VERIFY_PHONE_SUCCESS';
export const VERIFY_PHONE_ERROR = 'VERIFY_PHONE_ERROR';
export const VERIFY_PHONE_END = 'VERIFY_PHONE_END';
export const CLEAR_PHONE_NUMBER = 'CLEAR_PHONE_NUMBER';
